
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1698"}},[_c('path',{attrs:{"data-name":"Rectangle 2404","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1697","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1046","d":"M19.198 6.27h-15.2a1 1 0 00-1 1v5.606a7.119 7.119 0 0014.168 1h2.032a3.804 3.804 0 100-7.608zm0 5.608h-1.949V8.27h1.949a1.804 1.804 0 110 3.608z"}}),_c('path',{attrs:{"data-name":"Path 1047","d":"M4.49 4.417a1 1 0 001.414 0 2.919 2.919 0 000-4.124A1 1 0 104.49 1.707a.917.917 0 010 1.3 1 1 0 000 1.41z"}}),_c('path',{attrs:{"data-name":"Path 1048","d":"M9.205 4.417a1 1 0 001.415 0 2.916 2.916 0 000-4.126 1 1 0 00-1.414 1.416.913.913 0 010 1.294 1 1 0 00-.001 1.416z"}}),_c('path',{attrs:{"data-name":"Path 1049","d":"M13.922 4.417a1 1 0 001.415 0 2.919 2.919 0 000-4.126 1 1 0 10-1.414 1.416.915.915 0 010 1.294 1 1 0 00-.001 1.416z"}})])])])
          )
        }
      }
    